var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxDataGrid',_vm._b({attrs:{"id":"complatins-data-grid","data-source":_vm.complatins,"focused-row-enabled":true,"key-expr":"id","columns":_vm.complatinsColumns}},'DxDataGrid',_vm.commonProps.dataGrid,false))}
var staticRenderFns = []

export { render, staticRenderFns }